import { ActionType } from 'typesafe-actions';
import * as actions from './listActions';
import {
    CLEAR_SEARCH_RESULTS,
    GET_AZ_LIST_FAILURE,
    GET_AZ_LIST_REQUEST,
    GET_AZ_LIST_SUCCESS,
    GET_LIST_ITEM_PAGE_SUCCESS,
    GET_LIST_ITEM_PAGE_FAILURE,
    GET_SEARCH_LIST_FAILURE,
    GET_SEARCH_LIST_REQUEST,
    GET_SEARCH_LIST_SUCCESS,
    SET_ACTIVE_SLUG,
} from './listConstants';

export type ListAction = ActionType<typeof actions>;

export type ListState = Readonly<{
    activeSlug: string;
    totalPages: number;
    isLoading: boolean;
    isError: boolean;
    isSearchResults: boolean;
    searchResultsTerm: string;
    items: [];
}>;

export const initialState: ListState = {
    activeSlug: 'program', // TODO - default should be added to an env var to be able to change per institution
    totalPages: 0,
    isLoading: false,
    isError: false,
    isSearchResults: false,
    searchResultsTerm: '',
    items: [],
};

export default (state: ListState = initialState, action: ListAction) => {
    switch (action.type) {
        case SET_ACTIVE_SLUG:
            return {
                ...state,
                activeSlug: action.payload,
            };
        case GET_AZ_LIST_REQUEST:
            return {
                ...state,
                isLoading: true,
                items: [],
                searchResultsTerm: '',
            };
        case GET_AZ_LIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isError: false,
                items: action.payload.list,
                totalPages: action.payload.totalPages,
                isSearchResults: false,
            };
        case GET_AZ_LIST_FAILURE:
            return {
                ...state,
                isLoading: false,
                isError: true,
            };
        case GET_SEARCH_LIST_REQUEST:
            return {
                ...state,
                isLoading: true,
                items: [],
                searchResultsTerm: action.payload,
            };
        case GET_SEARCH_LIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                items: action.payload.list,
                totalPages: action.payload.totalPages,
                isSearchResults: true,
            };
        case GET_SEARCH_LIST_FAILURE:
            return {
                ...state,
                isLoading: false,
                isError: true,
            };
        case CLEAR_SEARCH_RESULTS:
            return {
                ...state,
                searchResultsTerm: '',
                isSearchResults: false,
            };
        case GET_LIST_ITEM_PAGE_SUCCESS: {
            if (!action.payload.page) {
                return state;
            }
            const { referrerUuid } = action.payload;
            const { path, catalogContentRevisionUuid } = action.payload.page;

            if (!catalogContentRevisionUuid) {
                return {
                    ...state,
                    //eslint-disable-next-line
                    items: state.items.map((item: any) => {
                        return item && item.uuid === referrerUuid
                            ? {
                                  ...item,
                                  _pagePath: path,
                                  isFetched: true,
                                  isListItemError: false,
                              }
                            : item;
                    }),
                };
            }
            return {
                ...state,
                //eslint-disable-next-line
                items: state.items.map((item: any) => {
                    return item && item.uuid === catalogContentRevisionUuid
                        ? {
                              ...item,
                              _pagePath: path,
                              isFetched: true,
                              isListItemError: false,
                          }
                        : item;
                }),
            };
        }
        case GET_LIST_ITEM_PAGE_FAILURE: {
            const { referrerUuid } = action.payload;
            return {
                ...state,
                //eslint-disable-next-line
                items: state.items.map((item: any) => {
                    return item && item.uuid === referrerUuid
                        ? {
                              ...item,
                              _pagePath: null,
                              isFetched: false,
                              isListItemError: true,
                          }
                        : item;
                }),
            };
        }
        default:
            return state;
    }
};
